import type { Level, LogEntry, Middleware, MiddlewareNext } from '../types'
import { isLevelFit, getConsoleMethod } from '../levels'


type Options = {
  level?: Level
}

// this middleware log all messages to console
function consoleMiddleware(options: Options): Middleware {
  const { level: middlewareLevel = 'debug' } = options

  return (entry: LogEntry, next: MiddlewareNext) => {
    const { level, message, contexts, extra } = entry

    if (isLevelFit(level, middlewareLevel)) {
      const method = getConsoleMethod(level)
      const args: any[] = colorizeMessage(message)

      if (contexts) {
        args.push('\ncontexts', contexts)
      }

      if (extra) {
        args.push('\nextra', extra)
      }

      method(...args)
    }

    next(entry)
  }
}

const analyticsStyle = 'font-weight: bold; color: #0000FF;'

const colorizeMessage = (message: LogEntry['message']): any[] => {
  if (typeof message === 'string') {
    const match = message.match(/(\[(Mixpanel|Snowplow|DataLayer|Iterable)])( (track) (.*)|)/)

    if (match) {
      if (match[3].length) {
        // track case
        return [
          message.replace(match[0], `%c${match[1]} %c${match[4]} %c${match[5]}`),
          analyticsStyle,
          '',
          'font-weight: bold;',
        ]
      }

      return [
        message.replace(match[0], `%c${match[1]}%c`),
        analyticsStyle,
        '',
      ]
    }
  }

  return [ message ]
}


export default consoleMiddleware
